import {
  COUNT_USER_FAILED,
  COUNT_USER_SUCCEED,
  COUNT_USER_PROCESSING,
  FETCH_USER_FAILED,
  FETCH_USER_SUCCEED,
  FETCH_USER_PROCESSING,
  GET_USER_FAILED,
  GET_USER_SUCCEED,
  GET_USER_PROCESSING,
  FETCH_USER_REGIONS_FAILED,
  FETCH_USER_REGIONS_SUCCEED,
  FETCH_USER_REGIONS_PROCESSING,
  SAVE_USER_FAILED,
  SAVE_USER_SUCCEED,
  SAVE_USER_PROCESSING,
  DELETE_USER_FAILED,
  DELETE_USER_SUCCEED,
  DELETE_USER_PROCESSING,
  HIDE_USER_ALERT,
  TOGGLE_SIDEBAR,
} from '../constants/user.constants'

const initialState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  deleting: false,
  deleted: false,
  errorMessage: '',
  list: [],
  total: 0,
  regions: [],
  record: null,
  sidebarOpen: false,
}

const user = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_FAILED:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errorMessage: action.payload.error,
      }
    case FETCH_USER_PROCESSING:
      return {
        ...state,
        fetching: true,
        fetched: false,
        errorMessage: '',
      }
    case FETCH_USER_SUCCEED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        list: action.payload.list,
        errorMessage: '',
      }
    case GET_USER_FAILED:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errorMessage: action.payload.error,
      }
    case GET_USER_PROCESSING:
      return {
        ...state,
        fetching: true,
        fetched: false,
        errorMessage: '',
      }
    case GET_USER_SUCCEED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        record: action.payload.record,
        errorMessage: '',
      }
    case COUNT_USER_FAILED:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errorMessage: action.payload.error,
      }
    case COUNT_USER_PROCESSING:
      return {
        ...state,
        fetching: true,
        fetched: false,
      }
    case COUNT_USER_SUCCEED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        total: action.payload.total,
      }
    case FETCH_USER_REGIONS_FAILED:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errorMessage: action.payload.error,
      }
    case FETCH_USER_REGIONS_PROCESSING:
      return {
        ...state,
        fetching: true,
        fetched: false,
      }
    case FETCH_USER_REGIONS_SUCCEED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        regions: action.payload.regions,
      }
    case SAVE_USER_FAILED:
      return {
        ...state,
        saving: false,
        saved: false,
        errorMessage: action.payload.error,
      }
    case SAVE_USER_PROCESSING:
      return {
        ...state,
        saving: true,
        saved: false,
      }
    case SAVE_USER_SUCCEED:
      return {
        ...state,
        saving: false,
        saved: true,
      }
    case DELETE_USER_FAILED:
      return {
        ...state,
        deleting: false,
        deleted: false,
        errorMessage: action.payload.error,
      }
    case DELETE_USER_PROCESSING:
      return {
        ...state,
        deleting: true,
        deleted: false,
      }
    case DELETE_USER_SUCCEED:
      return {
        ...state,
        deleting: false,
        deleted: true,
      }
    case HIDE_USER_ALERT:
      return {
        ...state,
        fetched: false,
        saved: false,
        errorMessage: '',
        deleted: false,
      }
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        sidebarOpen: !state.sidebarOpen,
      }
    default:
      return state
  }
}

export default user
